import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { debounceTime, switchMap } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class StorageService {
	private readonly minTimeBetweenSaves: number = 500;

	readonly contactDataKey: string = 'contactDataForm';
	readonly claimDataKey: string = 'claimDataForm';
	readonly confirmDataKey: string = 'confirmClaimForm';
	readonly claimRegisterKey: string = 'claimRegisterForm';

	save(key: string, value: any) {
		const claimData: any = this.get(this.claimDataKey);
		if(key === this.claimDataKey && claimData) {
			if ('docList' in claimData){
				value.docList = value.docList ? value.docList : claimData.docList;
			}
		}
		sessionStorage.setItem(key, JSON.stringify(value));
	}

	clear(key: string) {
		sessionStorage.removeItem(key);
	}

	get(key: string): object {
		const value = sessionStorage.getItem(key);
		return value ? JSON.parse(value) : undefined;
	}

	autoSaveForm(formKey: string, form: FormGroup) {
		form.valueChanges
			.pipe(
				debounceTime(this.minTimeBetweenSaves),
				switchMap(async (formValue) => {
					this.save(formKey, formValue);
				})
			)
			.subscribe();
	}
}
